import { useAuth } from "../../hooks";
import React, { useState } from "react";
import { TransactionDatePicker } from "../DatePicker";
import { formatDateToYMD } from "../../Utils/helperFunction";
import { UserPersonalDetails } from "../../api";
import ButtonLoader from "../Loader";
import { setSession } from "../../axios.config";
import { MobileInput, TextFormField } from "../Forms";

function RegisterForm({ setStateVariable, stateVariable }) {
  const {
    formData,
    errors,
    handleFieldChange,
    validateFormPage1,
    normalizeFormData,
    setErrors,
    handleFieldBlur,
    panError,
    setPanError,
    setFormData,
  } = useAuth();

  const [loading, setLoading] = useState(false);

  const SignUpData = {
    nationality: "IN",
    countryCode: "IN",
    dateOfBirth: formatDateToYMD(formData?.dob),
    firstName: formData?.firstName,
    middleName: formData?.middleName,
    lastName: formData?.lastName,
    mobile: `+91${formData?.mobileNumber}`,
    panNumber: formData?.pan,
  };

  const handleContinue = async () => {
    normalizeFormData();
    if (validateFormPage1()) {
      try {
        setLoading(true);
        const personalApi = await UserPersonalDetails(SignUpData);
        if (personalApi) {
          setSession("userId", personalApi?.data?.user);
          setStateVariable(stateVariable + 1);
        }
        setPanError("");
        setLoading(false);
      } catch (error) {
        setLoading(false);

        if (error?.message) {
          setPanError(error?.message);
        } else {
          setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            if (error?.error) {
              Object.entries(error?.error).forEach(([key, value]) => {
                newErrors[key] = value;
              });
            }
            return newErrors;
          });
        }
      }
    }
    setLoading(false);
  };

  const handleRawInputChange = (event) => {
    const { name, value } = event.target;

    // Update form data with raw input
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Validate incomplete dates
    if (value && value.length > 0 && value.length < 10) {
      setErrors((prev) => ({
        ...prev,
        [name]: "Please enter complete date in DD-MM-YYYY format",
      }));
    } else if (value && /^\d{2}-\d{1,2}-\d{1,3}$/.test(value)) {
      setErrors((prev) => ({
        ...prev,
        [name]: "Please enter a valid 4-digit year",
      }));
    }
  };

  return (
    <>
      <div className="w-full ">
        <div className="flex mb-[5px] justify-between ">
          <h1 className="text-[22px] lg:text-[26px]  leading-[26px] lg:leading-[34px]  font-geomanistMedium text-blackish  ">
            Personal Details
          </h1>
          <h2 className="mt-2 text-[16px] text-blueish flex justify-end">
            Step 1/3
          </h2>
        </div>
        <p className="text-sm mb-[20px] xl:mb-[36px] text-greyish font-geomanistRegular">
          Please enter your name and DOB exactly as per your passport
        </p>
        <div
          className={`grid grid-cols-1 sm:grid-cols-2 
         gap-y-[14px] md:gap-y-[25px]
               gap-x-[22px] xl:gap-x-[46px]`}
        >
          {/* First Name Input */}
          <TextFormField
            label="First Name"
            id="firstName"
            type="text"
            value={formData.firstName}
            onChange={handleFieldChange}
            onBlur={handleFieldBlur}
            error={errors.firstName}
          />
          {/* middle Name Input */}
          <TextFormField
            label="Middle Name (Optional)"
            id="middleName"
            type="text"
            value={formData.middleName}
            onChange={handleFieldChange}
            onBlur={handleFieldBlur}
          />

          {/* Last Name Input */}
          <TextFormField
            label="Last Name"
            id="lastName"
            type="text"
            value={formData.lastName}
            onChange={handleFieldChange}
            onBlur={handleFieldBlur}
            error={errors.lastName}
          />

          {/* Mobile Number Input */}
          <MobileInput
            value={formData.mobileNumber}
            onChange={handleFieldChange}
            onBlur={handleFieldBlur}
            error={errors.mobileNumber}
          />

          {/* PAN Number Input */}
          <TextFormField
            label="PAN Number"
            id="pan"
            type="text"
            value={formData.pan}
            onChange={handleFieldChange}
            onBlur={handleFieldBlur}
            error={errors.pan}
          />
          {/* DOB Input */}
          <div>
            <label
              htmlFor="dob"
              className="block text-[16px] font-geomanistRegular text-greyish mb-[9px] ml-2"
            >
              DOB
            </label>
            <TransactionDatePicker
              value={formData?.dob}
              className={`w-full text-blackShade !font-geomanistBold font-[16px] px-3 py-2 ${
                errors.dob ? "border-red-500" : ""
              }`}
              handleRawInputChange={handleRawInputChange}
              errorMessage={errors.dob}
              changeDate={(date) => handleFieldChange(date, "dob")}
              onBlur={handleFieldBlur}
            />
            {/* {errors.dob && (
              <p className="text-failed text-sm mt-1 ml-2">{errors.dob}</p>
            )} */}
          </div>
        </div>
        <span className="text-red-500 text-[14px]">{panError}</span>

        <button
          disabled={loading}
          type="submit"
          className="w-full  flex justify-center mt-[28px] text-white py-[10px] px-4 rounded-md bg-blueish font-geomanistMedium leading-[23px] text-[18px] hover:pointer"
          onClick={handleContinue}
        >
          {loading && <ButtonLoader className={"mr-2 h-2"} />} Continue
        </button>
      </div>
    </>
  );
}

export default RegisterForm;
